// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"2ccdb733","188":"c91d366d","297":"9a43cacf","453":"b5755f02"}[chunkId] + ".chunk.js";
};